import React, {Component} from "react";
import {Image} from "react-bootstrap";

class PlayerGoalInformation extends Component {
    render = () => {
        const {name, avatar, duration} = this.props;

        return (
            <div className="player-goal-information">
                <div className="duration"> {duration}' </div>
                <Image className="avatar" src={avatar}/>
                <div className="name"> {name} </div>
            </div>
        );
    };
}

export default PlayerGoalInformation;
